import { render, staticRenderFns } from "./FormFieldInputNumberFormattedTwoDecimals.vue?vue&type=template&id=2cbfe76f&"
import script from "./FormFieldInputNumberFormattedTwoDecimals.vue?vue&type=script&lang=ts&"
export * from "./FormFieldInputNumberFormattedTwoDecimals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports